import { app } from '../../../../../../../app';
import { Controller } from './delete-label.controller';

app.component('companyUserLabelDelete', {
    bindings: {close: '&', dismiss: '&', resolve: '<'},
    controller: Controller,
    templateUrl: require('./delete-label.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/saaspass-users/user-labels/label-settings/delete/delete-label.component.js